interface loginFormType {
    username:string,
    preferences?:string
}

class AuthError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "AuthError";
    }
}


export type {loginFormType}
export {AuthError}